export default "__VITE_ASSET__CbfNGq3X__"